
import React from 'react'

import checkedImg from './images/check_circle_black.svg';
import checkImg from './images/radio_button_unchecked_black.svg';

import checkedImgWhite from './images/check_circle_white.svg';
import checkImgWhite from './images/radio_button_unchecked_white.svg';

import  './styles/CheckBoxCircle.scss'

const CheckBoxCircle = (props) => {
  let check = props.on? props.light? checkedImgWhite : checkedImg : props.light? checkImgWhite : checkImg;
  return <span className="md-checkbox-circle" onClick={props.onClick}>
        <img src={check} alt="Checkbox" /> {props.label}
      </span>
}

CheckBoxCircle.defaultProps = {
  on: null,
  label: '',
  light: false
}

export default CheckBoxCircle;



// WEBPACK FOOTER //
// ./src/components/ui/CheckBoxCircle.jsx